const API_BASE =
  import.meta.env.VITE_API_BASE_URL

const ADMIN_TOKEN =
  import.meta.env.VITE_ADMIN_TOKEN

// ─────────────────────────────────────────────
// Shared Headers
// ─────────────────────────────────────────────
const headers = {
  'Content-Type': 'application/json',
  'x-admin-token': ADMIN_TOKEN
}

// ─────────────────────────────────────────────
// Helper
// ─────────────────────────────────────────────
async function parseResponse(res) {

  const data = await res.json()

  if (!res.ok) {
    throw new Error(
      data.error || 'Request failed'
    )
  }

  return data
}

// =============================================================================
// PORTFOLIO
// =============================================================================

export async function getPortfolio() {

  const res = await fetch(
    `${API_BASE}/portfolio`
  )

  return parseResponse(res)
}

export async function savePortfolio(data) {

  const res = await fetch(
    `${API_BASE}/portfolio`,
    {
      method: 'PUT',
      headers,
      body: JSON.stringify(data)
    }
  )

  return parseResponse(res)
}

// =============================================================================
// HERO
// =============================================================================

export async function getHero() {

  const res = await fetch(
    `${API_BASE}/portfolio/hero`
  )

  return parseResponse(res)
}

export async function saveHero(data) {

  const res = await fetch(
    `${API_BASE}/portfolio/hero`,
    {
      method: 'PUT',
      headers,
      body: JSON.stringify(data)
    }
  )

  return parseResponse(res)
}

// =============================================================================
// ABOUT
// =============================================================================

export async function getAbout() {

  const res = await fetch(
    `${API_BASE}/portfolio/about`
  )

  return parseResponse(res)
}

export async function saveAbout(data) {

  const res = await fetch(
    `${API_BASE}/portfolio/about`,
    {
      method: 'PUT',
      headers,
      body: JSON.stringify(data)
    }
  )

  return parseResponse(res)
}

// =============================================================================
// CONTACT
// =============================================================================

export async function getContact() {

  const res = await fetch(
    `${API_BASE}/portfolio/contact`
  )

  return parseResponse(res)
}

export async function saveContact(data) {

  const res = await fetch(
    `${API_BASE}/portfolio/contact`,
    {
      method: 'PUT',
      headers,
      body: JSON.stringify(data)
    }
  )

  return parseResponse(res)
}

// =============================================================================
// PROJECTS
// =============================================================================

export async function getProjects() {

  const res = await fetch(
    `${API_BASE}/portfolio/projects`
  )

  return parseResponse(res)
}

export async function addProject(data) {

  const res = await fetch(
    `${API_BASE}/portfolio/projects`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(data)
    }
  )

  return parseResponse(res)
}

export async function updateProject(
  id,
  data
) {

  const res = await fetch(
    `${API_BASE}/portfolio/projects/${id}`,
    {
      method: 'PUT',
      headers,
      body: JSON.stringify(data)
    }
  )

  return parseResponse(res)
}

export async function deleteProject(id) {

  const res = await fetch(
    `${API_BASE}/portfolio/projects/${id}`,
    {
      method: 'DELETE',
      headers
    }
  )

  return parseResponse(res)
}

// =============================================================================
// CERTIFICATES
// =============================================================================

export async function getCertificates() {

  const res = await fetch(
    `${API_BASE}/portfolio/certificates`
  )

  return parseResponse(res)
}

export async function addCertificate(data) {

  const res = await fetch(
    `${API_BASE}/portfolio/certificates`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(data)
    }
  )

  return parseResponse(res)
}

export async function updateCertificate(
  id,
  data
) {

  const res = await fetch(
    `${API_BASE}/portfolio/certificates/${id}`,
    {
      method: 'PUT',
      headers,
      body: JSON.stringify(data)
    }
  )

  return parseResponse(res)
}

export async function deleteCertificate(id) {

  const res = await fetch(
    `${API_BASE}/portfolio/certificates/${id}`,
    {
      method: 'DELETE',
      headers
    }
  )

  return parseResponse(res)
}

// =============================================================================
// EDUCATIONS
// =============================================================================

export async function getEducations() {

  const res = await fetch(
    `${API_BASE}/portfolio/educations`
  )

  return parseResponse(res)
}

export async function addEducation(data) {

  const res = await fetch(
    `${API_BASE}/portfolio/educations`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(data)
    }
  )

  return parseResponse(res)
}

export async function updateEducation(
  id,
  data
) {

  const res = await fetch(
    `${API_BASE}/portfolio/educations/${id}`,
    {
      method: 'PUT',
      headers,
      body: JSON.stringify(data)
    }
  )

  return parseResponse(res)
}

export async function deleteEducation(id) {

  const res = await fetch(
    `${API_BASE}/portfolio/educations/${id}`,
    {
      method: 'DELETE',
      headers
    }
  )

  return parseResponse(res)
}

// =============================================================================
// TOOLS
// =============================================================================

export async function getTools() {

  const res = await fetch(
    `${API_BASE}/portfolio/tools`
  )

  return parseResponse(res)
}

export async function addTool(data) {

  const res = await fetch(
    `${API_BASE}/portfolio/tools`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(data)
    }
  )

  return parseResponse(res)
}

export async function updateTool(
  id,
  data
) {

  const res = await fetch(
    `${API_BASE}/portfolio/tools/${id}`,
    {
      method: 'PUT',
      headers,
      body: JSON.stringify(data)
    }
  )

  return parseResponse(res)
}

export async function deleteTool(id) {

  const res = await fetch(
    `${API_BASE}/portfolio/tools/${id}`,
    {
      method: 'DELETE',
      headers
    }
  )

  return parseResponse(res)
}

// =============================================================================
// PROFILE IMAGE
// =============================================================================

export async function getProfileImage() {

  const res = await fetch(
    `${API_BASE}/portfolio/image`
  )

  const data =
    await parseResponse(res)

  return data.image
}

export async function saveProfileImage(
  image
) {

  const res = await fetch(
    `${API_BASE}/portfolio/image`,
    {
      method: 'PUT',
      headers,
      body: JSON.stringify({
        image
      })
    }
  )

  return parseResponse(res)
}

export async function deleteProfileImage() {

  const res = await fetch(
    `${API_BASE}/portfolio/image`,
    {
      method: 'DELETE',
      headers
    }
  )

  return parseResponse(res)
}

// =============================================================================
// RESUME
// =============================================================================

export async function getResume() {

  const res = await fetch(
    `${API_BASE}/portfolio/resume`
  )

  return parseResponse(res)
}

export async function saveResume(
  dataUrl,
  fileName
) {

  const res = await fetch(
    `${API_BASE}/portfolio/resume`,
    {
      method: 'PUT',
      headers,

      body: JSON.stringify({
        dataUrl,
        fileName
      })
    }
  )

  return parseResponse(res)
}

export async function deleteResume() {

  const res = await fetch(
    `${API_BASE}/portfolio/resume`,
    {
      method: 'DELETE',
      headers
    }
  )

  return parseResponse(res)
}